$(document).scroll(function() {
  const scrolledHeight = window.pageYOffset;
  const heightToTriggerSticky = $('.tutoring-benefits-slip').position().top;
  const docHeight = document.documentElement.scrollHeight;

  if (scrolledHeight > heightToTriggerSticky && scrolledHeight < docHeight - window.innerHeight) {
    $('.js-sticky-mobile-cta').fadeIn();
    $('.js-sticky-mobile-cta').removeClass('d-none');
    $('.js-sticky-mobile-cta').addClass('d-flex');
  } else {
    $('.js-sticky-mobile-cta').fadeOut();
    $('.js-sticky-mobile-cta').addClass('d-none');
    $('.js-sticky-mobile-cta').removeClass('d-flex');
  }
});